import { render, staticRenderFns } from "./DateFormatWithDotConsistencyAnalyse.vue?vue&type=template&id=058d3711&"
import script from "./DateFormatWithDotConsistencyAnalyse.vue?vue&type=script&lang=js&"
export * from "./DateFormatWithDotConsistencyAnalyse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports